import React from 'react';
import Sidebar from '../components/Sidebar.js'; // Import the Sidebar component

const Home = () => {
  return (
    <div className="flex">
      {/* Sidebar */}
      <Sidebar />
      {/* Main Content */}
      <div className="main-content flex-1 bg-gray-100 p-6 mt-16">
        <div className="bg-white shadow-md rounded-lg p-6">
          <h1 className="text-4xl font-semibold text-blue-600 mb-4">Admin Dashboard</h1>
          <p className="text-gray-700 mb-6">Welcome to the Admin Panel. Manage your application effectively here.</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Metrics Card 1 */}
            <div className="bg-blue-500 text-white p-4 rounded-lg shadow-lg">
              <h2 className="text-xl font-bold">Total Acacdemies</h2>
              <p className="text-3xl mt-2">1,234</p>
            </div>
            {/* Metrics Card 2 */}
            <div className="bg-green-500 text-white p-4 rounded-lg shadow-lg">
              <h2 className="text-xl font-bold">Active Batches</h2>
              <p className="text-3xl mt-2">56</p>
            </div>
            {/* Metrics Card 3 */}
            <div className="bg-red-500 text-white p-4 rounded-lg shadow-lg">
              <h2 className="text-xl font-bold">Pending Payments</h2>
              <p className="text-3xl mt-2">$4,567</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
